// Test IDs for the Equipo (Team management) feature.

export const TEAM = {
        explainerBanner: 'team-explainer-banner',
        addButton: 'team-add-button',
        table: 'team-table',
        rowPrefix: 'team-row-', // team-row-<userId>
        editButtonPrefix: 'team-edit-button-',
        deleteButtonPrefix: 'team-delete-button-',
        emptyState: 'team-empty-state',

        modalNameInput: 'team-modal-name-input',
        modalEmailInput: 'team-modal-email-input',
        modalPasswordInput: 'team-modal-password-input',
        modalPhoneInput: 'team-modal-phone-input',
        modalRoleSelect: 'team-modal-role-select',
        modalSpecialtyInput: 'team-modal-specialty-input',
        modalPhotoUpload: 'team-modal-photo-upload',
        modalSaveButton: 'team-modal-save-button',
        modalCancelButton: 'team-modal-cancel-button',
        modalScheduleDayPrefix: 'team-modal-schedule-day-', // + day index

        deleteConfirmButton: 'team-delete-confirm-button',
        deleteCancelButton: 'team-delete-cancel-button',
};
